<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render (h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      let iconName = 'iconfont menu-title ' + icon
      // vnodes.push(<i class={icon}/>)
      vnodes.push(<i class = {iconName}></i>)
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>
<style lang="scss">
.menu-title{
  display: inline-block;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SiderBar/Item.vue